import React, { Component } from 'react';
import { connect } from 'react-redux';
import Utility from '../../../Utility';

import { ReactComponent as IconSmaller } from './SourcebarIcons/smaller.svg';
import { ReactComponent as IconLarger } from './SourcebarIcons/larger.svg';
import { ReactComponent as IconSearch } from './SourcebarIcons/search.svg';

import './SourceBar.css';

class SourceBar extends Component {
	constructor(props) {
		super(props);

		this.state = {
			hasInitializedWhiteboard: false
		};
	}

    componentDidMount() {
        const { data, updatePlayerState } = this.props;

        // On first load, if showWhiteboard flag is set, display the first whiteboard only
        if (!this.state.hasInitializedWhiteboard) {
	        const showWB = data.recording.info.showWhiteboard;

	        // Initialize whiteboard visibility based on showWhiteboard flag
	        const tempVisiblePresets = JSON.parse(JSON.stringify(data.visiblePresets));
	        tempVisiblePresets.whiteboard = tempVisiblePresets.whiteboard.map((wb, idx) => ({
	            ...wb,
	            visible: showWB && idx === 0
	        }));

	        this.props.updatePlayerState({
	        	visiblePresets: tempVisiblePresets
	        });
            this.setState({ hasInitializedWhiteboard: true });
        }
    }

	buttonPressed = (index) => {
		// TODO: merge into single routine at the App? level
		var tempVisiblePresets = JSON.parse(JSON.stringify(this.props.data.visiblePresets));

		if (index.indexOf('wb') > -1) {
			index = parseInt(index.substring(2), 10);

			for (var i = tempVisiblePresets.whiteboard.length - 1; i >= 0; i--) {
				if (i === index) {
					// Toggle current whiteboard display
					tempVisiblePresets.whiteboard[i].visible = !tempVisiblePresets.whiteboard[i].visible;
				} else {
					// Hide all others
					tempVisiblePresets.whiteboard[i].visible = false;
				}
			}
		} else {
			index = parseInt(index.substring(2), 10);
			tempVisiblePresets.stage[index].visible = !tempVisiblePresets.stage[index].visible;
		}

		this.props.updatePlayerState({
			visiblePresets: tempVisiblePresets
		});
	}

	render() {
		let visibleCount = this.props.data.visiblePresets.stage.reduce(
			(previousValue, currentValue) => previousValue + (currentValue.visible === true ? 1 : 0), 0
		);

		return(
			<div id="sourcebar">
				{ this.props.data.visiblePresets.stage.map((button, index) => {
					return(<SourceButtonView sourceIndex={index} subArrayKey={'st' + index} key={index} visible={button.visible} label={ button.name } onButtonToggle={this.buttonPressed} onSizePress={this.changeSize} resizeable={this.props.data.visiblePresets.stage.length > 1} allowResize={visibleCount > 1}  />);
				}, this)}
				{ this.props.data.visiblePresets.whiteboard.map(function(button, index) {
					return(<SourceButtonView sourceIndex={index + this.props.data.visiblePresets.stage.length} subArrayKey={'wb' + index} key={'wb' + index} visible={button.visible} label={ button.name } onButtonToggle={this.buttonPressed} />);
				}, this)}
				<FeatureToggleButton
					show={this.props.data.recording.info.captions.length > 0}
					data={this.props.data}
					propertyToToggle="transcript"
					updatePlayerState={this.props.updatePlayerState}>Transcript</FeatureToggleButton>

				{/*<FeatureToggleButton
					show={this.props.data.recording.info.words.length > 0}
					data={this.props.data}
					propertyToToggle="wordeditor"
					updatePlayerState={this.props.updatePlayerState}>Word Editor</FeatureToggleButton>*/}

				<FeatureToggleButton
					show={this.props.data.recording.info.words.length > 0}
					data={this.props.data}
					propertyToToggle="transcripteditor"
					updatePlayerState={this.props.updatePlayerState}>Transcript Editor</FeatureToggleButton>
				<FeatureToggleButton
					show={!!this.props.data.recording.search_token}
					data={this.props.data}
					propertyToToggle="search"
					label="Search recording"
					updatePlayerState={this.props.updatePlayerState}><IconSearch /></FeatureToggleButton>
			</div>
		)
	}
}

class FeatureToggleButton extends Component {
	toggleState = (ev) => {
		var properties = {
			transcript: false,
			wordeditor: false,
			transcripteditor: false,
			search: false
		};

		if (this.props.data[this.props.propertyToToggle]) {
			this.logEventHandler('player_hide_' + this.props.propertyToToggle);
		} else {
			this.logEventHandler('player_show_' + this.props.propertyToToggle);
		}

		properties[this.props.propertyToToggle] = !this.props.data[this.props.propertyToToggle];

		this.props.updatePlayerState(properties);
	}

	logEventHandler = (event, params) => {
		Utility.logUserInteraction(event, params, { current_time: this.props.dynamic.currentTime });
	}

	render() {
		if (this.props.show === false) {
			return null;
		}

		var buttonClass = 'hiding',
			title = 'Show ';

		if (this.props.data[this.props.propertyToToggle]) {
			buttonClass = 'showing';
			title = 'Hide ';
		}

		return (
			<button className={buttonClass} onClick={this.toggleState} aria-label={this.props.label} aria-pressed={!!this.props.data[this.props.propertyToToggle]} title={title + (this.props.label || this.props.children)}>{this.props.children}</button>
		);
	}
}

class SourceButtonView extends Component {
	onclickHandler = (ev) => {
		if (this.props.visible) {
			this.logEventHandler('player_hide_source', { source_name: this.props.label });
		} else {
			this.logEventHandler('player_show_source', { source_name: this.props.label });
		}

		this.props.onButtonToggle(this.props.subArrayKey);
	}

	logEventHandler = (event, params) => {
		Utility.logUserInteraction(event, params, { current_time: this.props.dynamic.currentTime });
	}

	onmouseoverHandler = (ev) => {
		document.documentElement.classList.add('renderbox-' + this.props.subArrayKey + '-highlight');
	}

	onmouseoutHandler = (ev) => {
		document.documentElement.classList.remove('renderbox-' + this.props.subArrayKey + '-highlight');
	}

	changeSizeBigger = (ev) => {
		this.logEventHandler('player_increase_source', { source_name: this.props.label });
		Utility.emit('player.changesourcesize', {
			target: this.props.sourceIndex,
			action: 'bigger'
		});
	}

	changeSizeSmaller = (ev) => {
		this.logEventHandler('player_decrease_source', { source_name: this.props.label });
		Utility.emit('player.changesourcesize', {
			target: this.props.sourceIndex,
			action: 'smaller'
		});
	}

	render() {
		var className = 'hiding';

		if (this.props.visible === true) {
			className = 'showing';
		}

		return(
			<div className="source-buttons" onMouseOver={this.onmouseoverHandler} onMouseOut={this.onmouseoutHandler} >
				<button className={className} onClick={this.onclickHandler} title={(this.props.visible ? 'Hide ' : 'Show ') + this.props.label + ' (' + (this.props.sourceIndex+1) + ')'}>{ this.props.label }</button>
				{ this.props.resizeable ? <button disabled={!this.props.visible || !this.props.allowResize} className="size-button bigger" onClick={this.changeSizeBigger} title={'Increase ' + this.props.label + ' size'}><IconLarger /></button> : null }
				{ this.props.resizeable ? <button disabled={!this.props.visible || !this.props.allowResize} className="size-button smaller" onClick={this.changeSizeSmaller} title={'Decrease ' + this.props.label + ' size'}><IconSmaller /></button> : null }
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	dynamic: state.dynamic
});

FeatureToggleButton = connect(mapStateToProps) (FeatureToggleButton);
SourceButtonView = connect(mapStateToProps) (SourceButtonView);

export default SourceBar;
